import { combineReducers } from "redux";
import stepOneReducer from "./steps/stepOneSlice";
import stepTwoReducer from "./steps/stepTwoSlice";
import stepFourReducer from "./steps/stepFourSlice";
import stepFiveReducer from "./steps/stepFiveSlice";

const createReducer: any = () =>
  combineReducers({
    stepOne: stepOneReducer,
    stepTwo: stepTwoReducer,
    stepFour: stepFourReducer,
    stepFive: stepFiveReducer,
  });
export default createReducer;
